// import React from "react";
import { Col, Row } from "react-bootstrap";
import BlogCard from "./BlogCard";

export default function Blog({ blogsList = [], blogsRef, viewBlog }) {
  return (
    <section className="section-blog padding-b-50 padding-t-100" ref={blogsRef}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="col-12 d-flex justify-content-center">
              <div className="section-title bb-deal">
                <div className="section-detail text-center">
                  <h2 className="bb-title">
                    Blogs <span>deal</span>
                  </h2>
                  <p>Don't wait. The time will never be just right.</p>
                </div>
                {/* <div id="dealend" class="dealend-timer"></div> */}
              </div>
            </div>
            {blogsList.length > 0 ? (
              <div className="px-3 px-md-4">
                <Row className="g-4">
                  {blogsList.map((blog) => (
                    <Col
                      key={blog._id}
                      xs={12} // 1 per row on mobile
                      sm={12}
                      md={6} // 2 per row on tablets
                      lg={4} // 3 per row on desktops
                      xl={3} // 4 per row on large screens
                    >
                      <BlogCard blog={blog} viewBlog={viewBlog} />
                    </Col>
                  ))}
                </Row>
              </div>
            ) : (
              <div className="text-center text-muted py-5">
                <h5>No blog posts available.</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
